export default __webpack_public_path__ + "img/edSgWPVg.8355415c.svg";